declare namespace $ {

	type $mol_string__hint_giper_baza_auth_slot_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_giper_baza_auth_slot_2 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['prefix'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_giper_baza_auth_slot_3 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['run'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_check_icon__Icon_giper_baza_auth_slot_4 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['Run_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_giper_baza_auth_slot_5 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['running'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__enabled_giper_baza_auth_slot_6 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['run_enabled'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__label_giper_baza_auth_slot_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check_icon['label'] >
	>
	type $mol_bar__sub_giper_baza_auth_slot_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_button_copy__title_giper_baza_auth_slot_9 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['link'] >
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__text_giper_baza_auth_slot_10 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['key'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_list__rows_giper_baza_auth_slot_11 = $mol_type_enforce<
		ReturnType< $giper_baza_auth_slot['keys'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $giper_baza_auth_slot extends $mol_page {
		prefix( next?: string ): string
		run( next?: any ): any
		Prefix( ): $mol_string
		Run_icon( ): $mol_icon_play
		running( next?: boolean ): boolean
		run_enabled( ): boolean
		Running( ): $mol_check_icon
		Input( ): $mol_bar
		link( id: any): string
		key( id: any): string
		Key( id: any): $mol_button_copy
		keys( ): readonly(any)[]
		Keys( ): $mol_list
		title( ): string
		glob( ): $giper_baza_glob
		found( id: any, next?: readonly(string)[] ): readonly(string)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=slot.view.tree.d.ts.map